import React from "react"
import {
  Box,
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core"
import { AssociatedIdentifier } from "@root/store/types"
import AssociatedIdentifiersTable from "@root/components/AssociatedIdentifiersTable"
import { useSelector } from "react-redux"
import { selectAnalyticsAssociatedIdentifiers } from "@root/store/selectors"
import { useAppDispatch } from "@root/store"
import {
  getAssociatedIdentifiers,
  addAssociatedIdentifier,
  removeAssociatedIdentifier,
} from "@root/store/thunks"

const useStyles = makeStyles({
  button: {
    alignSelf: "center",
  },
})

const AssociatedIdentifiers: React.FC = () => {
  const [key, setKey] = React.useState<string>("")
  const [identifier, setIdentifier] = React.useState<string>("")

  const associatedIdentifiers = useSelector(
    selectAnalyticsAssociatedIdentifiers
  )

  const classes = useStyles()

  const dispatch = useAppDispatch()

  React.useEffect(() => {
    dispatch(getAssociatedIdentifiers())
  }, [dispatch])

  const add = React.useCallback(
    (identifier: AssociatedIdentifier) => {
      dispatch(addAssociatedIdentifier(identifier))
    },
    [dispatch]
  )

  const remove = React.useCallback(
    (identifier: string) => {
      dispatch(removeAssociatedIdentifier(identifier))
      dispatch(getAssociatedIdentifiers())
    },
    [dispatch]
  )

  return (
    <>
      <AssociatedIdentifiersTable
        associatedIdentifiers={associatedIdentifiers}
        onRemoveAssociatedIdentifier={remove}
      />

      <Typography variant="h6">Add New</Typography>
      <Box
        component="form"
        data-qa-selector="tags-form"
        onSubmit={(ev) => {
          ev.preventDefault()
          add({ [key]: identifier })
          setKey("")
          setIdentifier("")
        }}
      >
        <Grid container spacing={2}>
          <Grid item sm={5} xs={12}>
            <TextField
              fullWidth
              data-qa-selector="key-input"
              id="key-id"
              label="Key"
              value={key}
              onChange={(ev) => setKey(ev.target.value)}
            />
          </Grid>
          <Grid item sm={5} xs={12}>
            <TextField
              fullWidth
              data-qa-selector="identifier-input"
              id="identifier-id"
              label="Identifier"
              value={identifier}
              onChange={(ev) => setIdentifier(ev.target.value)}
            />
          </Grid>
          <Grid item sm={2} xs={12} className={classes.button}>
            <Button
              fullWidth
              data-qa-selector="submit"
              type="submit"
              variant="contained"
              disabled={!key || !identifier}
            >
              Add
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default AssociatedIdentifiers
